import { Observable } from 'rxjs';
import { PaymentsSessionCompany } from '@app/domain/models/payments-companies/payments-route-company';

/**
 * Comercios de Payments de los gestores PAYMENTS de la cuenta PROPIA del usuario,
 * con su valor de RUTA (`GET /api/gestor/services/` → `payments_company.id_company`).
 * Lectura de fondo: un fallo NO se propaga, se entrega lista vacía (falla cerrada aguas abajo).
 */
export abstract class PaymentsSessionCompaniesRepository {
  abstract getOwnPaymentsCompanies(polipayAccount: string): Observable<PaymentsSessionCompany[]>;
}
